import { useContext, useEffect } from "react";
import { Tabs } from "antd";
import { useNavigate } from "react-router";
import Integrations from "./Integrations";
import { AuthContext } from "../../../context/AuthContext";

const Settings = () => {
  const navigate = useNavigate();
  const { isRMView } = useContext(AuthContext);

  const items = [
    {
      key: "1",
      label: "Integrations",
      children: <Integrations />,
    },
  ];

  useEffect(() => {
    if (!isRMView) {
      navigate("/dashboard-view");
    }
  }, [isRMView, navigate]);

  return (
    <div>
      <h1 className="heading24px fw-bold">Settings</h1>
      <p className="heading16px mb10 text-color-848484 fw-normal">
        Manage your account preferences and system settings.
      </p>
      <Tabs items={items} />
    </div>
  );
};

export default Settings;
